import Link from 'next/link';
import styles from './styles.module.scss';

const Hamburger = props => {

    const {open} = props || {};
    return(
        <div className={`${styles.hamburger} active`} title="Menu">
            <div className={`${styles.hamburger__box} `}>
                <div className={`${styles.hamburger__inner} ${open ? 'active' : ''}`}></div>
            </div>
        </div>
    );
}

export default Hamburger;